import { getStore } from '../store/store';
import type { SearchTab } from 'owa-search-types/lib/types/SearchTab';

export default function getActiveScopeTab(): SearchTab | undefined {
    return getStore().activeScopeTab;
}
